import IndustryPageTemplate from "./IndustryPageTemplate";
import { photographersData } from "@/data/photographers";

export default function PhotographersPage() {
  return <IndustryPageTemplate data={photographersData} />;
}
